<template>
  <div>
    <FooterPageLayout v-model:selectedListItemIndexFromProps="selectedListItemIndex" :pageData="contactPageData">
      <div v-for="regionContent in regionContentList" :key="regionContent.title" class="infoRow wd-pt-4 wd-pb-4 <xs:wd-px-5">
        <p class="wd-text-gray80 wd-text-otempsm !wd-mb-2">{{ regionContent.title }}</p>
        <p class="!wd-mb-0 wd-text-omd">{{ regionContent.content }}</p>
      </div>
    </FooterPageLayout>
  </div>
</template>

<script lang="ts" setup>
import FooterPageLayout from '@/components/FooterPageLayout.vue'

defineOptions({
  name: 'ContactPage',
})

const { $i18n } = useNuxtApp()

const selectedListItemIndex = ref(0)

// the order of item in the regionsContentList should be the same as the order of the item in list in contactPageData
const regionsContentList = computed(() => [
  [
    {
      title: $i18n.t('contact_company_name'),
      content: $i18n.t('contact_company_tw'),
    },
    {
      title: $i18n.t('contact_email'),
      content: $i18n.t('cs_email_tw'),
    },
  ],
  [
    {
      title: $i18n.t('contact_company_name'),
      content: $i18n.t('contact_company_hk'),
    },
    {
      title: $i18n.t('contact_email'),
      content: $i18n.t('cs_email_hk'),
    },
  ],
  [
    {
      title: $i18n.t('contact_company_name'),
      content: $i18n.t('contact_company_my'),
    },
    {
      title: $i18n.t('contact_email'),
      content: $i18n.t('cs_email_my'),
    },
    {
      title: $i18n.t('contact_address'),
      content: $i18n.t('contact_address_my'),
    },
  ],
  [
    {
      title: $i18n.t('contact_company_name'),
      content: $i18n.t('contact_company_jp'),
    },
    {
      title: $i18n.t('contact_email'),
      content: $i18n.t('cs_email_jp'),
    },
  ],
  [
    {
      title: $i18n.t('contact_email'),
      content: $i18n.t('cs_email_th'),
    },
  ],
])
const regionContentList = computed(() => regionsContentList.value[selectedListItemIndex.value])

const contactPageData = computed(() => ({
  title: $i18n.t('footer_contact_us'),
  list: [
    {
      text: $i18n.t('general_taiwan'),
    },
    {
      text: $i18n.t('general_hk'),
    },
    {
      text: $i18n.t('general_my'),
    },
    {
      text: $i18n.t('general_jp'),
    },
    {
      text: $i18n.t('general_th'),
    },
  ],
}))
</script>

<style lang="scss" scoped>
.infoRow {
  border-bottom: 1px solid $gray40;

  &:last-child {
    margin-bottom: 24px;
  }
}

@include xxs {
  .infoRow {
    &:last-child {
      margin-bottom: 12px;
    }
  }
}
</style>
